import { render } from "./SupportRequest.vue?vue&type=template&id=b05ba40c&scoped=true"
import script from "./SupportRequest.vue?vue&type=script&lang=js"
export * from "./SupportRequest.vue?vue&type=script&lang=js"

import "./SupportRequest.vue?vue&type=style&index=0&id=b05ba40c&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b05ba40c"]])

export default __exports__